var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-drawer',{attrs:{"title":"","visible":_vm.advertisingBannerVisible,"direction":"ttb","size":"50%"},on:{"update:visible":function($event){_vm.advertisingBannerVisible=$event},"close":_vm.advertisingBannerVisibleClose}},[_c('el-image',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.advertiDetail.pcImgUrl,"fit":"fit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }